import * as types from './actionTypes';

const DEFAULT_LOOKAHEAD_PAGES = 8;

const initialState = {
    vacuumStatus: [],
    loading: false,
    error: null,
    rdsEvents: [],
    // RDS events are paged on the server, so the grid keeps its own loading
    // flag and lookahead pagination metadata.
    rdsEventsLoading: false,
    rdsEventsLastPageFetched: 1,
    rdsEventsHasNextPage: false,
    rdsEventsTotalNumberOfPages: 0,
    rdsEventsHasLookaheadPages: false,
    rdsEventsLookaheadPages: 0,
};

const RdsMonitorReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_VACUUM_STATUS:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case types.FETCH_VACUUM_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                vacuumStatus: action.payload.map(item => ({
                    ...item,
                    dead_tuples_percentage: item.vacuum_limit ? (item.dead_tuples * 100 / item.vacuum_limit).toFixed(2) : 100.00,
                    inserts_since_vacuum_percentage: item.vacuum_insert_limit ? (item.inserts_since_vacuum * 100 / item.vacuum_insert_limit).toFixed(2) : 100.00,
                })),
            };
        case types.FETCH_VACUUM_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case types.FETCH_RDS_EVENTS:
            return {
                ...state,
                rdsEventsLoading: true,
                error: null,
            };
        case types.FETCH_RDS_EVENTS_SUCCESS: {
            const additional = action.payload?.additional_data || {};
            const hasLookaheadPages = Boolean(additional?.has_lookahead_pages);
            return {
                ...state,
                rdsEventsLoading: false,
                rdsEvents: action.payload?.data || [],
                rdsEventsLastPageFetched: parseInt(additional?.page_number) || 1,
                rdsEventsHasNextPage: Boolean(additional?.has_next_page),
                rdsEventsTotalNumberOfPages: parseInt(additional?.total_number_of_pages) || 0,
                rdsEventsHasLookaheadPages: hasLookaheadPages,
                rdsEventsLookaheadPages: hasLookaheadPages ? (parseInt(additional?.lookahead_pages) || DEFAULT_LOOKAHEAD_PAGES) : 0,
            };
        }
        case types.FETCH_RDS_EVENTS_FAILURE:
            return {
                ...state,
                rdsEventsLoading: false,
                error: action.payload,
                rdsEvents: [],
                rdsEventsHasNextPage: false,
                rdsEventsHasLookaheadPages: false,
                rdsEventsLookaheadPages: 0,
            };
        default:
            return state;
    }
};

export default RdsMonitorReducer;
